import { FocusEventHandler, Ref } from "react";
import styled from "styled-components";
import { FloatingContext } from "@floating-ui/react";
import { shade0, shade300 } from "../../../styles/tokens";
import { normalStyles } from "../../body/Body.Parts";
import { INPUT_SPACE, ROW_HEIGHT, SelectOption } from "../Select.Parts";

// TEXT

// STYLES
export const InnerInput = styled.input<InnerInputProps>`
  flex: 1;
  width: ${INPUT_SPACE}rem;
  min-width: ${INPUT_SPACE}rem;
  padding-right: 1rem;
  padding-left: 0;

  height: ${({ $active }) => ($active ? `${ROW_HEIGHT}rem` : "0")};
  opacity: ${({ $active }) => ($active ? "1" : "0")};

  ${normalStyles};
  color: ${shade0};

  transition:
    height 0.3s ease,
    opacity 0.3s ease;

  &::placeholder {
    color: ${shade300};
  }

  &:focus {
    height: ${ROW_HEIGHT}rem;
    opacity: 1;
  }
`;

// DATA

// TYPES
export type Props = {
  /** General */
  disabled?: boolean; // Whether the entire control is disabled.

  /** Floating UI Context */
  context: FloatingContext; // The Floating UI context object
  ref: Ref<HTMLInputElement | null>; // Ref to the HTML input element, used by the parent for focus management.
  referenceProps: Record<string, unknown>; // Props generated by useInteractions (getReferenceProps) to spread onto the input element.
  listboxId: string; // The listbox ID for accessibility (aria-controls).
  activeIndex: number | null; // The currently "virtual" focused index (from list navigation) for accessibility (aria-activedescendant).
  setActiveIndex: (index: number | null) => void; // Function to set the active index in the parent component.

  /** Search State & Data */
  id: string; // The input's unique ID (for accessibility labeling).
  searchValue: string; // The current value of the search field.
  active: boolean; // True if the select has any placeholder, selections, or search value that should cause the input to be visible.
  filteredOptions: SelectOption[]; // The list of options filtered by the searchValue.
  placeholder?: string; // Optional placeholder text for the input when no value is present.
  setSearchValue: (value: string) => void; // Function to update the search input's value.

  /** Selection State */
  selection: (string | number)[]; // The current array of selected values.
  setSelection: (selection: (string | number)[]) => void; // Function to update the current selection array.

  /** Handler Functions */
  onBlur?: FocusEventHandler<HTMLInputElement>; // Optional external onBlur handler.
  handleSelect: (index: number) => void; // Handler called when an item is selected via Enter key in the list.
};

type InnerInputProps = {
  $active: boolean;
  disabled?: boolean; // Pass-through for native input disabled prop
};

// CONSTANTS

// FUNCTIONS

// ASSETS
